import { Blokk, Tabla, UresSor } from './Blokk.tsx';
import { KORZET_URES_SZOVEG, korzetAranyMondat } from './korzet.ts';
import type { KorzetValasz } from './tipusok.ts';

/** Körzeten kívüli kérések (az `elemzes_korzet` adatbázis-függvény válasza): névtelen számláló, lead nem keletkezik. */
export default function KorzetKivulBlokk({ d }: { d: KorzetValasz }) {
  return (
    <Blokk cim="Körzeten kívüli kérések" leiras="Akik az iroda körzetén kívüli címre kértek becslést, ezért nem indulhattak tovább. Csak darabszám, személyes adat nincs.">
      {d.db === 0 ? <UresSor szoveg={KORZET_URES_SZOVEG} /> : (
        <>
          <dl aria-label="Körzeten kívüli kérések összesítve" className="mt-4 grid grid-cols-2 gap-6 sm:max-w-md">
            <div><dt className="text-[13px] text-szoveg-halk">Körzeten kívüli kérés</dt><dd className="szam-nagy mt-1 text-[26px]">{d.db}</dd></div>
          </dl>
          {d.arany !== null && <p className="mt-3 text-sm">{korzetAranyMondat(d.arany)}</p>}
          <Tabla nev="Leggyakoribb körzeten kívüli területek" minSzel={320} fej={[{ cim: 'Terület' }, { cim: 'Kérés', j: true }]}>
            {d.teruletek.map((t) => (
              <tr key={t.kod}>
                <td>{t.nev}</td>
                <td className="j szam">{t.darab}</td>
              </tr>
            ))}
          </Tabla>
        </>
      )}
    </Blokk>
  );
}
